import styled from "styled-components";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";
import { lighten } from "@mui/material";

export const TemplateWrapper = styled.div<{ colormatrix: TemplateColorObject }>`
	width: 430px;
	max-width: 100%;
	margin: 0 auto;

	font-family: "Georgia", serif;
	color: #4a2830;
	overflow: hidden;
	box-shadow: 0 0 60px rgba(183, 110, 121, 0.15);

	/* ---- HERO ---- */
	.section_01 {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;

		overflow: hidden;
		button {
			background: ${props => props.colormatrix.button.background};
			color: ${props => props.colormatrix.button.text};
			border: none;
			padding: 12px 32px;
			border-radius: 50px;
			font-size: 13px;
			letter-spacing: 2px;
			text-transform: uppercase;
			cursor: pointer;
			box-shadow: 0 4px 20px rgba(139, 58, 71, 0.3);
			transition:
				transform 0.2s,
				box-shadow 0.2s;
			margin-top: 20px;
			&:hover {
				transform: translateY(-2px);
				box-shadow: 0 8px 24px rgba(139, 58, 71, 0.4);
			}
		}
	}
	.hero-floral {
		position: absolute;
		width: 180px;
		height: 180px;
		opacity: 0.5;
	}
	.hero-floral--top {
		top: -40px;
		right: -40px;
		transform: rotate(30deg);
	}
	.hero-floral--bottom {
		bottom: -40px;
		left: -40px;
		transform: rotate(200deg);
	}
	.floral-svg {
		width: 100%;
		height: 100%;
	}
	.main_image-wrap {
		position: relative;
		inset: 0;
		.fader {
			height: 100px;
			width: 100%;
			background: ${props => props.colormatrix.fader};
			position: absolute;
			bottom: -5px;
		}
	}
	.main_image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.hero-overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(to bottom, rgba(249, 213, 211, 0.3) 0%, rgb(191 191 191 / 88%) 90%);
		background: linear-gradient(to bottom, rgba(249, 213, 211, 0.3) 0%, rgba(255, 248, 245, 0.88) 90%);
	}
	.img-placeholder {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 3rem;
	}
	.img-placeholder--hero {
		font-size: 5rem;
	}
	.img-placeholder__icon {
		filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1));
	}
	.hero-content {
		position: relative;
		z-index: 2;
		text-align: center;
		background: #fff;
		padding: 40px 20px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.hero-intro-tag {
		font-size: 11px;
		letter-spacing: 3px;
		color: #b76e79;
		text-transform: uppercase;
		margin-bottom: 12px;
		font-family: "Arial", sans-serif;
	}
	.groom_name,
	.bride_name {
		font-size: 40px;
		font-weight: normal;
		margin: 0;
		color: #8b3a47;
		letter-spacing: 2px;
		line-height: 1.1;
		text-shadow: 0 2px 12px rgba(139, 58, 71, 0.15);
	}
	.hero-ampersand {
		font-size: 52px;
		color: #c9a96e;
		line-height: 1;
		margin: 4px 0;
		font-family: "Georgia", serif;
	}
	.hero-divider {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		margin: 16px 0 10px;
	}
	.hero-divider__line {
		display: block;
		width: 60px;
		height: 1px;
		background: #c9a96e;
		opacity: 0.6;
	}
	.hero-divider__diamond {
		color: #c9a96e;
		font-size: 10px;
	}
	.date {
		font-size: 18px;
		color: #b76e79;
		letter-spacing: 1.5px;
		margin: 0;
		font-family: "Arial", sans-serif;
	}
	.intro_message {
		font-size: 14px;
		color: #9c6b73;
		margin: 0 0 20px;
		font-style: italic;
	}
	.save_date {
		background: ${props => props.colormatrix.button.background};
		color: ${props => props.colormatrix.button.text};
		border: none;
		padding: 12px 32px;
		border-radius: 50px;
		font-size: 13px;
		letter-spacing: 2px;
		text-transform: uppercase;
		cursor: pointer;
		box-shadow: 0 4px 20px rgba(139, 58, 71, 0.3);
		transition:
			transform 0.2s,
			box-shadow 0.2s;
		margin-top: 20px;
		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 8px 24px rgba(139, 58, 71, 0.4);
		}
	}

	/* ---- COUNTDOWN ---- */
	.section_02 {
		background: ${props => props.colormatrix.background};
		padding: 40px 24px;
		text-align: center;

		.count_down_wrapper {
			display: flex;
			justify-content: center;
			gap: 12px;

			.counter_boxes_wrapper {
				display: flex;
				justify-content: center;
				gap: 12px;
				flex-wrap: wrap;
				.counter_box_wrapper {
					.counter_box {
						background: rgba(255, 255, 255, 0.08);
						border: 1px solid rgba(201, 169, 110, 0.3);
						border-radius: 12px;
						padding: 16px 12px;
						min-width: 50px;
						display: flex;
						flex-direction: column;
						align-items: center;
						backdrop-filter: blur(8px);
						font-size: 32px;
						color: #fff;
						font-weight: bold;
						line-height: 1;
						font-family: "Arial", sans-serif;
					}
					p {
						font-size: 10px;
						color: #c9a96e;
						text-transform: uppercase;
						letter-spacing: 1.5px;
						margin-top: 6px;
						font-family: "Arial", sans-serif;
					}
				}
			}
		}
	}
	.countdown-title {
		color: rgba(255, 255, 255, 0.7);
		font-size: 16px;
		letter-spacing: 1px;
		margin: 0 0 8px;
		direction: rtl;
		font-style: italic;
	}
	.countdown-heading {
		color: #c9a96e;
		font-size: 20px;
		font-weight: normal;
		letter-spacing: 2px;
		margin: 0 0 28px;
	}
	.countdown-grid {
		display: flex;
		justify-content: center;
		gap: 12px;
	}
	.countdown-unit {
		background: rgba(255, 255, 255, 0.08);
		border: 1px solid rgba(201, 169, 110, 0.3);
		border-radius: 12px;
		padding: 16px 15px;
		min-width: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		backdrop-filter: blur(8px);
	}
	.countdown-value {
		font-size: 32px;
		color: #fff;
		font-weight: bold;
		line-height: 1;
		font-family: "Arial", sans-serif;
	}
	.countdown-label {
		font-size: 10px;
		color: #c9a96e;
		text-transform: uppercase;
		letter-spacing: 1.5px;
		margin-top: 6px;
		font-family: "Arial", sans-serif;
	}

	/* ---- INTRO ---- */
	.section_03 {
		padding: 48px 28px;
		text-align: center;
		background: #fff8f5;
		position: relative;
	}
	.section_03::before {
		content: "";
		display: block;
		width: 60px;
		height: 2px;
		background: linear-gradient(90deg, transparent, #c9a96e, transparent);
		margin: 0 auto 24px;
	}
	.quran {
		font-size: 16px;
		color: #b76e79;
		direction: rtl;
		margin: 0 0 20px;
		line-height: 1.8;
		font-style: italic;
	}
	.main_intro {
		font-size: 18px;
		color: #8b3a47;
		margin: 0 0;
		font-style: italic;
	}
	.sub_intro {
		font-size: 13px;
		color: #9c6b73;
		line-height: 1.7;
		margin: 0 0;
		font-family: "Arial", sans-serif;
	}
	.couple-images {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 16px;
	}
	.couple-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		.partner_img {
			width: 300px;
			max-height: 400px;
			border-radius: 16px;
			border: 3px solid #c9a96e;
			box-shadow: 0 8px 24px rgba(183, 110, 121, 0.25);
			font-size: 2.5rem;
		}
	}

	.couple-name {
		font-size: 20px;
		color: #8b3a47;
		margin: 0;
		letter-spacing: 1px;
	}
	.couple-heart {
		font-size: 28px;
		color: #b76e79;
		margin-bottom: 32px;
	}

	/* ---- QURAN ---- */
	.section_04 {
		background: ${props => props.colormatrix.secondaryBackground};
		padding: 40px 24px;
		text-align: center;
	}
	.quran-card {
		border: 1px solid #c9a96e;
		border-radius: 16px;
		padding: 32px 20px;
		background: rgba(255, 255, 255, 0.6);
		backdrop-filter: blur(4px);
	}
	.quran-ornament {
		color: #c9a96e;
		font-size: 12px;
		letter-spacing: 6px;
		margin-bottom: 16px;
		opacity: 0.8;
	}
	.bismillah {
		font-size: 20px;
		color: #8b3a47;
		direction: rtl;
		margin: 0 0 16px;
		line-height: 1.8;
	}
	.verse {
		font-size: 16px;
		color: #4a2830;
		direction: rtl;
		line-height: 2;
		margin: 0 0 16px;
		font-style: italic;
	}
	.ending {
		font-size: 14px;
		color: #b76e79;
		direction: rtl;
		margin: 0;
		font-style: italic;
	}

	/* ---- LOVE STORY ---- */
	.section_05 {
		padding: 48px 0px;
		background: #fff8f5;
		text-align: center;
	}
	.story_image {
		max-width: 350px;
		border-radius: 16px;
		margin-bottom: 28px;
		font-size: 3rem;
	}
	.section_title {
		font-size: 26px;
		font-weight: normal;
		color: #8b3a47;
		margin: 0 0 12px;
		letter-spacing: 1px;
	}
	.story-divider {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 28px;
		justify-content: center;
	}
	.story-divider span:first-child,
	.story-divider span:last-child {
		flex: 1;
		max-width: 80px;
		height: 1px;
		background: #c9a96e;
		opacity: 0.5;
		display: block;
	}
	.story-divider__icon {
		font-size: 16px;
	}
	.stories {
		display: flex;
		flex-direction: column;
		gap: 20px;
		text-align: left;
		padding: 20px;
	}
	.story-item {
		display: flex;
		gap: 16px;
		background: linear-gradient(
			135deg,
			${props => lighten(props.colormatrix.main, 1)},
			${props => lighten(props.colormatrix.main, 0.8)}
		);
		border: 1px solid rgba(201, 169, 110, 0.2);
		border-radius: 12px;
		padding: 20px 16px;
	}
	.story-item__num {
		font-size: 28px;
		color: #c9a96e;
		opacity: 0.5;
		font-family: "Georgia", serif;
		line-height: 1;
		min-width: 36px;
	}
	.story-item__title {
		font-size: 16px;
		color: #8b3a47;
		margin: 0 0 6px;
		font-weight: normal;
		letter-spacing: 0.5px;
	}
	.story-item__content {
		font-size: 13px;
		color: #9c6b73;
		margin: 0;
		line-height: 1.7;
		font-family: "Arial", sans-serif;
	}

	/* ---- GALLERY ---- */
	.section_06 {
		padding: 45px 15px;
		background: ${props => props.colormatrix.secondaryBackground};
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.gallery-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;
		margin-top: 8px;
	}
	.gallery-item {
		border-radius: 12px;
		overflow: hidden;
		background: linear-gradient(135deg, #f9d5d3, #e8b4b8);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.gallery-item--normal {
		height: 140px;
	}
	.gallery-item--tall {
		height: 200px;
		grid-column: span 1;
	}
	.gallery-placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 2.5rem;
		background: linear-gradient(135deg, rgba(249, 213, 211, 0.6), rgba(201, 169, 110, 0.2));
	}

	/* ---- COMMENTS ---- */
	.section_07 {
		padding: 48px 24px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #fff8f5;
	}
	.comment_title {
		font-size: 18px;
		font-weight: normal;
		color: #b76e79;
		margin: 0 0 8px;
		font-style: italic;
		text-align: center;
	}
	.comment_description {
		font-size: 13px;
		color: #9c6b73;
		margin: 0 0 24px;
		font-family: "Arial", sans-serif;
		text-align: center;
	}
	.comment-form {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 24px;
	}
	.comment-input {
		width: 100%;
		border: 1px solid rgba(183, 110, 121, 0.3);
		border-radius: 12px;
		padding: 14px 16px;
		font-size: 14px;
		color: #4a2830;
		background: rgba(255, 255, 255, 0.8);
		font-family: "Georgia", serif;
		resize: none;
		box-sizing: border-box;
		outline: none;
		transition: border-color 0.2s;
		&:focus {
			border-color: #b76e79;
		}
	}
	.comment-submit {
		background: linear-gradient(135deg, #b76e79, #8b3a47);
		color: #fff;
		border: none;
		padding: 12px 24px;
		border-radius: 50px;
		font-size: 14px;
		cursor: pointer;
		letter-spacing: 1px;
		transition: transform 0.2s;
		&:hover {
			transform: translateY(-2px);
		}
	}
	.comments-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
		text-align: left;
	}
	.comment-bubble {
		background: linear-gradient(135deg, rgba(249, 213, 211, 0.5), rgba(252, 232, 216, 0.5));
		border: 1px solid rgba(201, 169, 110, 0.2);
		border-radius: 12px;
		padding: 14px 16px;
		font-size: 13px;
		color: #4a2830;
		line-height: 1.6;
		font-family: "Arial", sans-serif;
	}
	.comment-bubble p {
		margin: 0;
	}

	/* ---- LOCATION ---- */
	.section_08 {
		position: relative;
		padding: 48px 24px;
		background: ${props => props.colormatrix.secondaryBackground};
		display: flex;
		flex-direction: column;
		align-items: center;

		button {
			background: ${props => props.colormatrix.button.background};
			color: ${props => props.colormatrix.button.text};
			padding: 12px 32px;
			border-radius: 50px;
			font-size: 14px;
			letter-spacing: 1.5px;
			cursor: pointer;
			transition: all 0.2s;
			&:hover {
				background: #8b3a47;
				color: #fff;
			}
		}
		.footer-floral {
			position: absolute;
			width: 140px;
			height: 140px;
			bottom: -30px;
			right: -20px;
			opacity: 0.15;
			svg {
				fill: red;
			}
		}
	}
	.location_name {
		font-size: 15px;
		color: #b76e79;
		margin: 0 0 20px;
		letter-spacing: 1px;
		font-style: italic;
		font-family: "Arial", sans-serif;
	}
	.location_map {
		border-radius: 16px;
		overflow: hidden;
		border: 2px solid #c9a96e;
		margin-bottom: 20px;
		box-shadow: 0 8px 24px rgba(183, 110, 121, 0.2);
	}
	.open_map {
		background: transparent;
		border: 2px solid #8b3a47;
		color: #8b3a47;
		padding: 12px 32px;
		border-radius: 50px;
		font-size: 14px;
		letter-spacing: 1.5px;
		cursor: pointer;
		transition: all 0.2s;
		&:hover {
			background: #8b3a47;
			color: #fff;
		}
	}

	/* ---- FOOTER ---- */
	.section_09 {
		background: ${props => props.colormatrix.background};
		padding: 40px 24px 32px;
		text-align: center;
		position: relative;
		overflow: hidden;
	}
	.footer-floral {
		position: absolute;
		width: 140px;
		height: 140px;
		bottom: -30px;
		right: -20px;
		opacity: 0.15;
	}
	.credit {
		color: #fff;
		font-size: 12px;
		margin: 0 0 8px;
		letter-spacing: 2px;
		text-transform: uppercase;
		font-family: "Arial", sans-serif;
	}
	.instagram {
		color: #c9a96e;
		font-size: 14px;
		text-decoration: none;
		letter-spacing: 1px;
		&:hover {
			text-decoration: underline;
		}
	}

	@media (max-width: 430px) {
		width: 100%;
		.groom_name,
		.bride_name {
			font-size: 32px;
		}
		.countdown-unit {
			min-width: 58px;
			padding: 12px 10px;
		}
		.countdown-value {
			font-size: 26px;
		}
		.groom_image,
		.bride_image {
			width: 100px;
			height: 100px;
		}
	}
`;
